import { GetServerSidePropsContext } from 'next'

import { CONFIG_B2B_DOMAIN_SUFFIX } from '@src/config/env'
import { STORE_PROGRAM_ID_HEADER, B2B_TENANT_HEADER } from '@src/constants/api.headers.constants'
import { B2B_DENIED_DOMAINS } from '@src/constants/b2b-denied-domains'
import { STORE_PROGRAM_ID_KEY } from '@src/quince-site-common/src/services/cartCheckoutService/constants'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

import { getStorage } from '../enhancedStorage'

export const getStoreProgramIdFromStorage = (): string | null => {
  if (!isBrowser()) return null

  try {
    return getStorage().getItem(STORE_PROGRAM_ID_KEY)
  } catch (error) {
    console.error('Error getting storeProgramId from localStorage:', error)
    return null
  }
}

export const getStoreProgramIdHeaders = (): Record<string, string> => {
  if (!isBrowser()) return {}

  const isDev = process.env.NODE_ENV === 'development'
  const isB2BMode = window.location.pathname.includes('b2b')
  const storeProgramId = getStoreProgramIdFromStorage()

  if (storeProgramId && (!isDev || isB2BMode))
    return {
      [STORE_PROGRAM_ID_HEADER]: storeProgramId,
    }

  return {}
}

export const isB2BDeniedDomain = (domain: string): boolean => {
  try {
    const inputUrl = new URL(domain)

    return B2B_DENIED_DOMAINS.some(deniedDomain => {
      if (!deniedDomain) return false
      try {
        const deniedUrl = new URL(deniedDomain)
        return inputUrl.origin === deniedUrl.origin
      } catch {
        return inputUrl.origin.includes(deniedDomain)
      }
    })
  } catch (error) {
    console.error('Error checking B2B denied domain:', error)
    return false
  }
}

export const getB2BHeaders = (domain?: string): Record<string, string> => {
  if (!domain || isB2BDeniedDomain(domain)) return {}

  return { ...getStoreProgramIdHeaders() }
}

export const isB2BDomain = (host?: string): boolean => {
  return host?.endsWith(CONFIG_B2B_DOMAIN_SUFFIX) ?? false
}

export const getB2BTenant = (ctx: GetServerSidePropsContext): string | undefined => {
  const host = ctx.req.headers.host

  //this is to run b2b in local environment with tenant header
  if (process.env.NODE_ENV === 'development' && host?.includes('localhost')) {
    const tenant = ctx.req.headers[B2B_TENANT_HEADER] as string
    return tenant
  }

  if (!isB2BDomain(host)) {
    return undefined
  }

  // Extract tenant name by removing the domain suffix
  const tenant = host?.slice(0, -CONFIG_B2B_DOMAIN_SUFFIX.length)

  // Validate tenant name (should not be empty and should not contain dots)
  if (!tenant || tenant.includes('.')) {
    return undefined
  }

  return tenant
}
